// assets/search-optimization.js
// Capture the first click on the search button, stop Boost’s handlers,
// show a quick loading state, then do a native form.submit() on the next tick.
document.addEventListener('click', (event) => {
  const btn = event.target.closest('#hc-header-search-bar button.search__button');
  if (!btn) return;

  // Prevent Boost Commerce's JS from running here and block its handlers
  event.stopImmediatePropagation();
  event.preventDefault();

  // Show a quick loading state on the button
  btn.classList.add('is-loading');

  // Schedule the native form submission immediately after paint
  const form = btn.closest('form');
  if (form) {
    setTimeout(() => form.submit(), 0);
  }
}, { capture: true });


// Intercept banner icon clicks
document.addEventListener('click', (event) => {
  const el = event.target.closest('.highlights-banners-icon');
  if (!el) return;
  event.stopImmediatePropagation();
  event.preventDefault();
  el.classList.add('is-loading');
  setTimeout(() => window.location.href = el.getAttribute('href'), 0);
}, { capture: true });

// Intercept announcement bar links
document.addEventListener('click', (event) => {
  const el = event.target.closest('#shopify-section-announcement-bar a.announcement-bar__link');
  if (!el) return;
  event.stopImmediatePropagation();
  event.preventDefault();
  el.classList.add('is-loading');
  setTimeout(() => window.location.href = el.getAttribute('href'), 0);
}, { capture: true });
